import { IInsuranceContract } from '@alberta/konexi-shared';
import { Inject, Injectable, NgZone } from '@angular/core';
import { InsuranceContractChannel } from 'src/app/business/insurance-contract/contracts/insurance-contract-channel';
import { IAppController } from 'src/app/common/contracts/controller/app-controller';
import { IDispatcher } from 'src/app/common/contracts/dispatch/dispatcher';
import { IPlatformSync, PlatformSyncToken } from 'src/app/common/contracts/sync/platform-sync';
import { AppController } from 'src/app/common/controller/app-controller';
import { Dispatcher } from 'src/app/common/dispatch/dispatcher';

import { InsuranceContractModelName } from '../../models/model-names';
import { SyncProgressEvent } from '../../models/sync-progress-event';
import { EventService } from '../event.service';
import { SyncService } from './sync.service';

@Injectable()
export class InsuranceContractSyncService extends SyncService<IInsuranceContract> {
  constructor(
    @Inject(AppController) appController: IAppController,
    @Inject(Dispatcher) dispatcher: IDispatcher<IInsuranceContract>,
    eventService: EventService<SyncProgressEvent>,
    ngZone: NgZone,
    @Inject(PlatformSyncToken) platformSync: IPlatformSync
  ) {
    super(InsuranceContractModelName, appController, dispatcher, eventService, ngZone, platformSync);
  }
  public canSync(channel: string): boolean {
    return (
      channel === InsuranceContractChannel.CREATE ||
      channel === InsuranceContractChannel.EDIT ||
      channel === InsuranceContractChannel.DELETE
    );
  }
}
